import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface SkeletonProps {
  className?: string;
}
const Skeleton: FC<SkeletonProps> = ({ className }) => {
  return (
    <div className={twMerge('bg-gray-200 animate-pulse', className)}>
      {/* to make skeleton able to inline with <li /> */}
      <div className="opacity-0 text-[1px]">.</div>
    </div>
  );
};

export default Skeleton;
